import { GOOGLE, LINKEDIN, META } from "../utils/constants";

const GOOGLE_ATC_BASE = "https://adstransparency.google.com";
const LINKEDIN_AD_LIBRARY_BASE = "https://www.linkedin.com/ad-library/detail";
export const DEFAULT_GOOGLE_ATC_REGION = "anywhere";

export const buildMetaAdLibraryUrl = ({ libraryID }) => {
  const resolvedLibraryID = String(libraryID || "").trim();
  if (!resolvedLibraryID) return null;

  return `https://www.facebook.com/ads/library/?id=${encodeURIComponent(resolvedLibraryID)}`;
};

export const buildGoogleCreativeUrl = ({
  advertiserId,
  creativeId,
  region = DEFAULT_GOOGLE_ATC_REGION,
}) => {
  const resolvedAdvertiserId = String(advertiserId || "").trim();
  const resolvedCreativeId = String(creativeId || "").trim();
  const resolvedRegion = String(region || DEFAULT_GOOGLE_ATC_REGION).trim();

  if (!resolvedAdvertiserId || !resolvedCreativeId) return null;

  return `${GOOGLE_ATC_BASE}/advertiser/${encodeURIComponent(resolvedAdvertiserId)}/creative/${encodeURIComponent(resolvedCreativeId)}?region=${encodeURIComponent(resolvedRegion)}`;
};

export const buildLinkedInAdLibraryUrl = ({ libraryID }) => {
  const resolvedLibraryID = String(libraryID || "").trim();
  if (!resolvedLibraryID) return null;

  return `${LINKEDIN_AD_LIBRARY_BASE}/${encodeURIComponent(resolvedLibraryID)}`;
};

export const resolveCompetitorAdsPlatform = ({
  pageValue,
  fallbackPlatform = META,
}) => {
  const platform = String(pageValue?.platform || "")
    .trim()
    .toLowerCase();

  if (platform === GOOGLE) return GOOGLE;
  if (platform === META) return META;
  if (platform === LINKEDIN.toLowerCase()) return LINKEDIN;

  const resolvedFallback = String(fallbackPlatform || META)
    .trim()
    .toLowerCase();

  if (resolvedFallback === GOOGLE) return GOOGLE;
  if (resolvedFallback === LINKEDIN.toLowerCase()) return LINKEDIN;

  return META;
};

export const getCompetitorAdExternalUrl = ({
  platform = META,
  pageId,
  libraryID,
}) => {
  const resolvedPlatform = String(platform || META)
    .trim()
    .toLowerCase();

  if (resolvedPlatform === GOOGLE) {
    return buildGoogleCreativeUrl({
      advertiserId: pageId,
      creativeId: libraryID,
      region: DEFAULT_GOOGLE_ATC_REGION,
    });
  }

  if (resolvedPlatform === LINKEDIN.toLowerCase()) {
    return buildLinkedInAdLibraryUrl({ libraryID });
  }

  return buildMetaAdLibraryUrl({ libraryID });
};

export const getCompetitorAdExternalUrlFromItem = (item) => {
  if (!item) return null;

  return getCompetitorAdExternalUrl({
    platform: item.platform,
    pageId: item.pageId,
    libraryID: item.libraryID ?? item.id,
  });
};
